// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__N3PAE","error":"Textarea_error__7quxu","readonly":"Textarea_readonly__2IzZy","disabled":"Textarea_disabled__27KLi"};